import React, {ReactNode, useEffect, useState} from 'react';
import {DetailGrid, Utility, wdiCore} from '@/components/GridWidget';
import {WdiCardTitle, WdiModalAppResult, WdiModalProps} from '@/components/WdiControls';
import {Button, Dropdown, Input, Menu, message} from 'antd';
import {initFieldDisplayFormater, TableColumnRanderFormats,} from '@/components/WdiBus/TableColumnRanderFormats';
import {NsGrid} from '@/components/GridWidget/GridDefProps';
import DataStore from '@/components/GridWidget/DataStore';
import RebateInfoSelectApp from './RebateInfoSelect';
import {ResponseStatus} from '@/utils/request';
import {WdiInputNumber} from '@/components/WdiControls/WdiInputNumber';
import {WdiPanel} from '@/components/WdiControls/WdiPanel';
import {ImportModalApp} from '@/components/WdiControls/WdiImport';
import {Enum} from '@/enums/system';
import {GridApi} from '@/services/gridapi';
import {WdiSelect, WdiSelectFormat} from '@/components/WdiControls/WdiSelect';
import {toExcel, ToExcelProps} from '@/components/WdiControls/WdiExcel';
import useWindowSize from '@/utils/useWindowSize';
import {ShipTo} from '@/services/mdm/shipto';
import RebateSpDetailEditApp from "@/pages/contract/RebatePaymentApply/components/DetailEdit";
import {Position} from "@/services/basic/position";
import PageControl from '@/components/WdiBus/FormPage';
import ModifyPaymentAmountModalApp from "@/pages/sales/sp/components/ModifyPaymentAmount";

const ModalAppTypeEnums = {
  None: 0,
  Insert: 1,
  Edit: 2,
  Import: 3,
  Select: 4,
};

const initRowFieldConfigs = (record: any) => {
  const columns = [
    'startDate',
    'endDate',
    'revenueType',
    'paymentMethodId',
    'amountSa',
    'amountPaid',
    'settlementExplain',
    'boId',
    'bohqId',
    'productNamesFg',
    'extPolicyName',
    'modifiedUserId',
    'modifiedReason',
  ];
  if (record.amountStatement) {
    columns.push('amountStatement');
  }
  return columns;
};

export type DetailForApplyProps = {
  data?: any;
  dataSource: any[];
  onChange?: (dataSource: any) => void;
  onClose?: (result?: WdiModalAppResult) => void;
};

const vatTypeValidate = (vatType?: any) => {
  if (!vatType || wdiCore.Object.IsNullOrUndefined(vatType.vatTypeId)) {
    message.error("请先选择税率").then();
    return false
  }
  return true;
};

const RebatePaymentDetailsForApplyPanel: React.FC<DetailForApplyProps> = (props) => {
  /// Grid初始化配置，GridSettings请求完数据之后再进行加载
  const [isLoaded, setIsLoaded] = useState(false);
  const [gridSettings, setGridSettings] = useState<any>({});
  const [detailModalProps, setDetailModalProps] = useState<WdiModalProps>({visible: false});
  const {data, dataSource, onChange} = props;
  const [importExcels, setImportExcels] = useState<ToExcelProps[]>([]);

  const onClose = () => {
    setDetailModalProps({
      visible: false,
      title: '',
      type: ModalAppTypeEnums.None,
      id: null,
      data: null,
    });
  };

  const onDetailSave = (result?: WdiModalAppResult) => {
    const rows = result?.data;
    let resultData: any[] = [];
    if (rows && rows.length > 0) {
      if (rows.length + dataSource.length > 1000) {
        message.error('明细数量过多请分开申请');
        return;
      }
      rows.forEach((item: any) => {
        if (dataSource.findIndex((row) => row.rebateInfoId == item.rebateInfoId) < 0) {
          resultData.push(item);
        }
        ShipTo.search({isActive: true, soldToCode: item.soldToCode}).then((shipToRes) => {
          if (shipToRes.data && shipToRes.data.length === 1) {
            item.shipToCode = shipToRes.data[0].shipToCode;
            item.shipToName = shipToRes.data[0].shipToName;
          }
        });
      });
      if (resultData.length > 0) {
        onChange?.(DataStore.addMulti(dataSource, resultData));
      }
    }
    onClose();
  };

  const onImportSave = (uploadResult: any) => {
    if (uploadResult.code == ResponseStatus.SUCCESS) {
      onChange?.(DataStore.init(uploadResult?.data?.data));
      onClose();
    }
  };

  const initImportExcel = () => {
    const shipToSheet = {
      dataLoading: async (params: any) => {
        return await ShipTo.searchExcel(
          Object.assign(
            {
              withPermissions: true,
              isActive: true,
            },
            params,
          ),
        );
      },
      data: null,
      names: [
        {name: 'shipToCode', displayName: '收货地编号'},
        {name: 'shipToName', displayName: '收货地名称'},
        {name: 'soldToCode', displayName: '客户编号'},
        {name: 'soldToName', displayName: '客户名称'},
        {name: 'boName', displayName: '四级使用部门'},
      ],
      sheetName: '收货地',
    };
    const importExcels = [
      {
        name: '全部下载',
        sheetProps: [shipToSheet],
      },

      {
        name: '收货地列表',
        sheetProps: [shipToSheet],
      },
    ];
    setImportExcels(importExcels);
  };

  useEffect(() => {
    GridApi.searchConfig({id: 'FormRebateSPDetail', allowModifyColumns: true}).then(
      (response) => {
        const settings: any = Object.assign({}, response.data, {
          actionsAlign: NsGrid.ActionsAlign.Left,
          showAggr: true,
          showExpandedRow: true,
        });

        initFieldDisplayFormater(settings.formSchema.allFields);

        settings.formSchema.allFields.startDate.getDisplayFormater = (
          text: any,
          record: any,
          index: any,
        ) => {
          return wdiCore.Date.DateToString(text);
        };

        settings.formSchema.allFields.amountSs.aggr = TableColumnRanderFormats.sumAggr(
          'amountSs',
          2,
        );
        settings.formSchema.allFields.amountNotPaid.aggr = TableColumnRanderFormats.sumAggr(
          'amountNotPaid',
          2,
        );
        settings.formSchema.allFields.amountInVat.aggr = TableColumnRanderFormats.sumAggr(
          'amountInVat',
          2,
        );
        settings.formSchema.allFields.amountExVat.aggr = TableColumnRanderFormats.sumAggr(
          'amountExVat',
          2,
        );

        settings.formSchema.allFields.rowNumber.width = 50;
        settings.formSchema.allFields.rebateInfoId.width = 120;
        settings.formSchema.allFields.fperiod.width = 95;
        settings.formSchema.allFields.soldToCode.width = 120;
        settings.formSchema.allFields.shipToCode.width = 120;
        settings.formSchema.allFields.ecId.width = 100;
        settings.formSchema.allFields.amountSs.width = 100;
        settings.formSchema.allFields.amountNotPaid.width = 120;
        settings.formSchema.allFields.amountInVat.width = 150;
        settings.formSchema.allFields.amountExVat.width = 165;
        settings.formSchema.allFields.remark.width = 120;
        settings.formSchema.allFields.productNamesRebate.width = 120;
        initImportExcel();
        setGridSettings(settings);
        setIsLoaded(true);
      },
    );
  }, []);

  const pageGridSettings = Object.assign({}, gridSettings);
  pageGridSettings.antdProps = {
    dataSource,
    initRowFieldConfigs: (record: any) => {
      return initRowFieldConfigs(record);
    },
    pagination: {
      defaultPageSize: 10,
      showSizeChanger: true,
    },
  };
  if (pageGridSettings && pageGridSettings.formSchema && pageGridSettings.formSchema.actions) {
    Utility.setActionCallback(
      pageGridSettings.formSchema.actions,
      'SystemDelete',
      async (grid: any, action: any, record: any) => {
        if (confirm('确定要删除该行吗？')) {
          onChange?.(DataStore.del(dataSource, record.uid));
          message.success('删除成功');
        }
      },
    );
  }

  const editColumn = {
    shipToCode: (_t: any, record: any, index: any) => {
      if (record.soldToCode && !record.shipToCode) {
        ShipTo.search({isActive: true, soldToCode: record.soldToCode}).then((shipToRes) => {
          if (shipToRes.data && shipToRes.data.length === 1) {
            const {...newRecord} = record;
            newRecord.shipToCode = shipToRes.data[0].shipToCode;
            newRecord.shipToName = shipToRes.data[0].shipToName;
            onChange?.(DataStore.edit(dataSource, newRecord));
          }
        });
      }
      return (
        <WdiSelect
          {...{
            style: {width: '100%'},
            allowClear: false,
            placeholder: '请选择收货地',
            labelInValue: true,
            remote: true,
            value: record.shipToCode
              ? {
                value: record.shipToCode,
                label: wdiCore.String.CodeOrName(record.shipToCode, record.shipToName),
              }
              : null,
            reloadKey: record.soldToCode,
            dataLoading: async (params) => {
              const response = await ShipTo.ajaxSearch(
                Object.assign(
                  {
                    isActive: true,
                    soldToCode: record.soldToCode,
                  },
                  params,
                ),
              );
              return response?.data?.map((item) => {
                return {value: item.shipToCode, label: item.codeOrName};
              });
            },
            onChange: (value) => {
              if (value) {
                const shipToCode = WdiSelectFormat.getvalue(value);
                ShipTo.get(shipToCode).then((responseResult) => {
                  const {...newRecord} = record;
                  newRecord.shipToCode = responseResult.data.shipToCode;
                  newRecord.shipToName = responseResult.data.shipToName;
                  onChange?.(DataStore.edit(dataSource, newRecord));
                });
              }
            },
          }}
        />
      );
    },
    amountInVat: (_t: any, record: any, index: any) => {
      return (
        <WdiInputNumber
          value={record.amountInVat}
          onBlur={(e: any) => {
            const {...newRecord} = record;
            newRecord.amountInVat = wdiCore.Number.ToNumber(e.target.value, 2);
            if (!wdiCore.Object.IsNullOrUndefined(newRecord.vatTypeValue)) {
              newRecord.amountExVat = wdiCore.Number.ToNumber(newRecord.amountInVat / (1 + newRecord.vatTypeValue), 2,);
              newRecord.tax = wdiCore.Number.ToNumber(newRecord.amountInVat - newRecord.amountExVat, 2,);
            }
            onChange?.(DataStore.edit(dataSource, newRecord));
          }}
        />
      );
    },
    amountExVat: (value: any, record: any, index: any) => {
      return wdiCore.Number.AmountToString(value);
    },
    remark: (_t: any, record: any, index: any) => {
      return (
        <Input
          value={record.remark}
          onChange={(e: any) => {
            const {...newRecord} = record;
            newRecord.remark = e.target.value;
            onChange?.(DataStore.edit(dataSource, newRecord));
          }}
        />
      );
    },
  };

  return (
    <>
      <WdiPanel
        title={<WdiCardTitle iconType={Enum.IconType.DETAIL_INFO} title="核销明细信息"/>}
        extra={
          <>
            <Button
              type="primary"
              onClick={() => {
                if (vatTypeValidate(data.vatType)) {
                  const newDataSource = [...dataSource];
                  newDataSource.forEach((item) => {
                    item.amountInVat = wdiCore.Number.ToNumber(item.amountNotPaid, 2);
                    if (!wdiCore.Object.IsNullOrUndefined(item.vatTypeValue)) {
                      item.amountExVat = wdiCore.Number.ToNumber(item.amountInVat / (1 + item.vatTypeValue), 2,);
                      item.tax = wdiCore.Number.ToNumber(item.amountInVat - item.amountExVat, 2);
                    }
                  });
                  onChange?.(newDataSource);
                }
              }}
              style={{float: 'right', marginRight: 10}}
            >
              全部含税核销
            </Button>
            <Button
              type="primary"
              onClick={() => {
                if (vatTypeValidate(data.vatType)) {
                  const newDataSource = [...dataSource];
                  newDataSource.forEach((item) => {
                    item.amountExVat = wdiCore.Number.ToNumber(item.amountNotPaid, 2);
                    if (!wdiCore.Object.IsNullOrUndefined(item.vatTypeValue)) {
                      item.amountInVat = wdiCore.Number.ToNumber(item.amountExVat * (1 + item.vatTypeValue), 2,);
                      item.tax = wdiCore.Number.ToNumber(item.amountInVat - item.amountExVat, 2);
                    }
                  });
                  onChange?.(newDataSource);
                }
              }}
              style={{float: 'right', marginRight: 10}}
            >
              全部未税核销
            </Button>
            <Button
              type="primary"
              onClick={() => {
                if (vatTypeValidate(data.vatType)) {
                  setDetailModalProps({
                    visible: true,
                    title: '选择待核销的返利费用',
                    type: ModalAppTypeEnums.Select,
                    id: null,
                    data: {...data, dataSource: dataSource},
                  });
                }
              }}
              style={{float: 'right', marginRight: 10}}
            >
              选择返利单
            </Button>
            {dataSource.findIndex((item) => item.needMatchStatement) > -1 ? (
              <Dropdown.Button
                buttonsRender={(buttons: ReactNode[]) => {
                  return [buttons[0], <Button type={"primary"} style={{width: 50, fontSize: 12}}>更多</Button>]
                }}
                type="primary"
                onClick={() => {
                  if (vatTypeValidate(data.vatType)) {
                    setDetailModalProps({
                      title: '核销明细导入',
                      visible: true,
                      type: ModalAppTypeEnums.Import,
                    });
                  }
                }}
                overlay={
                  <Menu
                    items={[
                      {
                        key: 'amountStatement',
                        label: '按对账单金额核销',
                        onClick: () => {
                          if (vatTypeValidate(data.vatType)) {
                            const newDataSource = [...dataSource];
                            newDataSource.forEach((item) => {
                              if (item.amountStatement) {
                                item.amountInVat = wdiCore.Number.ToNumber(item.amountStatement - item.amountPaid, 2,);
                                if (!wdiCore.Object.IsNullOrUndefined(item.vatTypeValue)) {
                                  item.amountExVat = wdiCore.Number.ToNumber(item.amountInVat / (1 + item.vatTypeValue), 2,);
                                  item.tax = wdiCore.Number.ToNumber(item.amountInVat - item.amountExVat, 2,);
                                }
                              }
                            });
                            onChange?.(newDataSource);
                          }
                        },
                      },
                    ]}
                  />
                }
                style={{float: 'right'}}
              >
                导入
              </Dropdown.Button>
            ) : (
              <Button
                type="primary"
                onClick={() => {
                  if (vatTypeValidate(data.vatType)) {
                    setDetailModalProps({
                      title: '核销明细导入',
                      visible: true,
                      type: ModalAppTypeEnums.Import,
                    });
                  }
                }}
                style={{float: 'right'}}
              >
                导入
              </Button>
            )}
          </>
        }
      >
        {isLoaded &&
          detailModalProps.visible &&
          detailModalProps.type == ModalAppTypeEnums.Select && (
            <RebateInfoSelectApp {...detailModalProps} onClose={onClose} onSave={onDetailSave}/>
          )}
        {isLoaded && detailModalProps.visible && detailModalProps.type == ModalAppTypeEnums.Import && (
          <ImportModalApp
            title={detailModalProps.title}
            visible={detailModalProps.visible}
            settingsUrl="/expenseapi/spButtons/getImportSettings"
            uploadingUrl="/expenseapi/spButtons/importUploading"
            onClose={onClose}
            onSave={onImportSave}
            importExcels={importExcels}
            clientParameters={{
              pageTypeId: data.pageTypeId,
              paymentMethodId: data.paymentMethodId,
              vatTypeId: data.vatType.vatTypeId,
              details: JSON.stringify(dataSource),
              isCreate: true,
            }}
          />
        )}
        {isLoaded && (
          <DetailGrid
            {...pageGridSettings}
            params={data}
            editColumn={editColumn}
            autoColumn={['rowNumber']}
          />
        )}
      </WdiPanel>
    </>
  );
};
export default RebatePaymentDetailsForApplyPanel;

export const RebatePaymentDetailsForFgApplyPanel: React.FC<DetailForApplyProps> = (props) => {
  /// Grid初始化配置，GridSettings请求完数据之后再进行加载
  const [isLoaded, setIsLoaded] = useState(false);
  const [gridSettings, setGridSettings] = useState<any>({});
  const [detailModalProps, setDetailModalProps] = useState<WdiModalProps>({visible: false});
  const {data, dataSource, onChange} = props;

  const onClose = () => {
    setDetailModalProps({
      visible: false,
      title: '',
      type: ModalAppTypeEnums.None,
      id: null,
      data: null,
    });
  };

  const onDetailSave = (result?: WdiModalAppResult) => {
    const rows = result?.data;
    let resultData: any[] = [];
    if (rows && rows.length > 0) {
      if (rows.length + dataSource.length > 1000) {
        message.error('明细数量过多请分开申请');
        return;
      }
      rows.forEach((item: any) => {
        if (dataSource.findIndex((row) => row.rebateInfoId == item.rebateInfoId) < 0) {
          resultData.push(item);
        }
      });
      if (resultData.length > 0) {
        onChange?.(DataStore.addMulti(dataSource, resultData));
      }
    }
    onClose();
  };

  const onImportSave = (uploadResult: any) => {
    if (uploadResult.code == ResponseStatus.SUCCESS) {
      onChange?.(DataStore.init(uploadResult?.data?.data));
      onClose();
    }
  };

  useEffect(() => {
    GridApi.searchConfig({id: 'FormRebateSPDetailForFg', allowModifyColumns: true}).then(
      (response) => {
        const settings: any = Object.assign({}, response.data, {
          actionsAlign: NsGrid.ActionsAlign.Left,
          showAggr: true,
          showExpandedRow: true,
        });

        initFieldDisplayFormater(settings.formSchema.allFields);

        settings.formSchema.allFields.startDate.getDisplayFormater = (
          text: any,
          record: any,
          index: any,
        ) => {
          return wdiCore.Date.DateToString(text);
        };

        settings.formSchema.allFields.amountSs.aggr = TableColumnRanderFormats.sumAggr(
          'amountSs',
          2,
        );
        settings.formSchema.allFields.amountNotPaid.aggr = TableColumnRanderFormats.sumAggr(
          'amountNotPaid',
          2,
        );
        settings.formSchema.allFields.amountInVat.aggr = TableColumnRanderFormats.sumAggr(
          'amountInVat',
          2,
        );
        settings.formSchema.allFields.amountExVat.aggr = TableColumnRanderFormats.sumAggr(
          'amountExVat',
          2,
        );

        settings.formSchema.allFields.rowNumber.width = 50;
        settings.formSchema.allFields.rebateInfoId.width = 120;
        settings.formSchema.allFields.fperiod.width = 95;
        settings.formSchema.allFields.soldToCode.width = 120;
        settings.formSchema.allFields.ecId.width = 100;
        settings.formSchema.allFields.amountSs.width = 100;
        settings.formSchema.allFields.amountNotPaid.width = 120;
        settings.formSchema.allFields.amountInVat.width = 150;
        settings.formSchema.allFields.amountExVat.width = 165;
        settings.formSchema.allFields.remark.width = 120;
        settings.formSchema.allFields.productNamesRebate.width = 120;

        setGridSettings(settings);
        setIsLoaded(true);
      },
    );
  }, []);

  const editColumn = {
    amountInVat: (_t: any, record: any, index: any) => {
      return (
        <WdiInputNumber
          value={record.amountInVat}
          onBlur={(e: any) => {
            const {...newRecord} = record;
            newRecord.amountInVat = wdiCore.Number.ToNumber(e.target.value, 2);
            if (!wdiCore.Object.IsNullOrUndefined(newRecord.vatTypeValue)) {
              newRecord.amountExVat = wdiCore.Number.ToNumber(newRecord.amountInVat / (1 + newRecord.vatTypeValue), 2,);
              newRecord.tax = wdiCore.Number.ToNumber(newRecord.amountInVat - newRecord.amountExVat, 2,);
            }
            onChange?.(DataStore.edit(dataSource, newRecord));
          }}
        />
      );
    },
    amountExVat: (value: any, record: any, index: any) => {
      if (Enum.PageType.PAYMENT_CONTRACT_FREE_GOODS == data.pageTypeId) {
        return wdiCore.Number.AmountToString(value);
      } else if (
        Enum.PageType.PAYMENT_CONTRACT_ACCOUNT_REDUCE == data.pageTypeId ||
        Enum.PageType.PAYMENT_CONTRACT_THIRD_PART == data.pageTypeId
      ) {
        return (
          <WdiInputNumber
            value={record.amountExVat}
            onBlur={(e: any) => {
              const {...newRecord} = record;
              newRecord.amountExVat = wdiCore.Number.ToNumber(e.target.value, 2);
              newRecord.amountInVat = record.amountInVat;
              newRecord.tax = wdiCore.Number.ToNumber(newRecord.amountInVat - newRecord.amountExVat, 2,);
              onChange?.(DataStore.edit(dataSource, newRecord));
            }}
          />
        );
      }
    },
    remark: (_t: any, record: any, index: any) => {
      return (
        <Input
          value={record.remark}
          onChange={(e: any) => {
            const {...newRecord} = record;
            newRecord.remark = e.target.value;
            onChange?.(DataStore.edit(dataSource, newRecord));
          }}
        />
      );
    },
  };

  const pageGridSettings = Object.assign({}, gridSettings);
  pageGridSettings.antdProps = {
    dataSource,
    initRowFieldConfigs: (record: any) => {
      return initRowFieldConfigs(record);
    },
    pagination: {
      defaultPageSize: 10,
      showSizeChanger: true,
    },
  };
  if (pageGridSettings && pageGridSettings.formSchema && pageGridSettings.formSchema.actions) {
    Utility.setActionCallback(
      pageGridSettings.formSchema.actions,
      'SystemDelete',
      async (grid: any, action: any, record: any) => {
        if (confirm('确定要删除该行吗？')) {
          onChange?.(DataStore.del(dataSource, record.uid));
          message.success('删除成功');
        }
      },
    );
  }

  return (
    <>
      <WdiPanel
        title={<WdiCardTitle iconType={Enum.IconType.DETAIL_INFO} title="费用明细信息"/>}
        extra={
          <>
            <Button
              type="primary"
              onClick={() => {
                if (vatTypeValidate(data.vatType)) {
                  const newDataSource = [...dataSource];
                  newDataSource.forEach((item) => {
                    item.amountInVat = wdiCore.Number.ToNumber(item.amountNotPaid, 2);
                    if (!wdiCore.Object.IsNullOrUndefined(item.vatTypeValue)) {
                      item.amountExVat = wdiCore.Number.ToNumber(item.amountInVat / (1 + item.vatTypeValue), 2,);
                      item.tax = wdiCore.Number.ToNumber(item.amountInVat - item.amountExVat, 2);
                    }
                  });
                  onChange?.(newDataSource);
                }
              }}
              style={{float: 'right', marginRight: 10}}
            >
              全部含税核销
            </Button>
            <Button
              type="primary"
              onClick={() => {
                if (vatTypeValidate(data.vatType)) {
                  const newDataSource = [...dataSource];
                  newDataSource.forEach((item) => {
                    item.amountExVat = wdiCore.Number.ToNumber(item.amountNotPaid, 2);
                    if (!wdiCore.Object.IsNullOrUndefined(item.vatTypeValue)) {
                      item.amountInVat = wdiCore.Number.ToNumber(item.amountExVat * (1 + item.vatTypeValue), 2,);
                      item.tax = wdiCore.Number.ToNumber(item.amountInVat - item.amountExVat, 2);
                    }
                  });
                  onChange?.(newDataSource);
                }
              }}
              style={{float: 'right', marginRight: 10}}
            >
              全部未税核销
            </Button>
            <Button
              type="primary"
              onClick={() => {
                setDetailModalProps({
                  visible: true,
                  title: '选择待核销的返利费用',
                  type: ModalAppTypeEnums.Select,
                  id: null,
                  data: {...data, dataSource: dataSource},
                });
              }}
              style={{float: 'right', marginRight: 10}}
            >
              选择返利单
            </Button>
            <Button
              type="primary"
              onClick={() => {
                if (vatTypeValidate(data.vatType)) {
                  setDetailModalProps({
                    title: '核销明细导入',
                    visible: true,
                    type: ModalAppTypeEnums.Import,
                  });
                }
              }}
              style={{float: 'right'}}
            >
              导入
            </Button>
          </>
        }
      >
        {isLoaded &&
          detailModalProps.visible &&
          detailModalProps.type == ModalAppTypeEnums.Select && (
            <RebateInfoSelectApp {...detailModalProps} onClose={onClose} onSave={onDetailSave}/>
          )}
        {isLoaded && detailModalProps.visible && detailModalProps.type == ModalAppTypeEnums.Import && (
          <ImportModalApp
            title={detailModalProps.title}
            visible={detailModalProps.visible}
            settingsUrl="/expenseapi/spButtons/getImportSettings"
            uploadingUrl="/expenseapi/spButtons/importUploading"
            onClose={onClose}
            onSave={onImportSave}
            clientParameters={{
              pageTypeId: data.pageTypeId,
              paymentMethodId: data.paymentMethodId,
              soldToCode: data.soldToCode,
              companyCode: data.companyCode,
              vatTypeId: data.vatType.vatTypeId,
              ecId: data.ecId,
              details: JSON.stringify(dataSource),
              isCreate: true,
            }}
          />
        )}
        {isLoaded && (
          <DetailGrid
            {...pageGridSettings}
            params={data}
            editColumn={editColumn}
            autoColumn={['rowNumber']}
          />
        )}
      </WdiPanel>
    </>
  );
};

export const RebatePaymentDetailsForApprovalPanel: React.FC<DetailForApplyProps> = (props) => {
  /// Grid初始化配置，GridSettings请求完数据之后再进行加载
  const [isLoaded, setIsLoaded] = useState(false);
  const [gridSettings, setGridSettings] = useState<any>({});

  const [modalProps, setModalProps] = useState<WdiModalProps>({visible: false, type: ModalAppTypeEnums.None});
  const [doesAccess, setDoesAccess] = useState<{ modifyAmount: boolean }>({modifyAmount: false});
  const {width} = useWindowSize();
  const {data, dataSource, onChange} = props;

  useEffect(() => {
    Promise.all([GridApi.searchConfig({id: 'FormRebateSPDetailForApproval', allowModifyColumns: true}),
      Position.access({useCaseId: Enum.UseCase.RSP, operateTypeIds: [Enum.OperateType.MODIFY_AMOUNT]}),
    ]).then((dataArray) => {
      const response = dataArray[0];
      const allowModifyAmountRes = dataArray[1];
      const allowModifyAmount = allowModifyAmountRes.code == ResponseStatus.SUCCESS && allowModifyAmountRes.data == true;
      setDoesAccess({modifyAmount: allowModifyAmount})

      const settings: any = Object.assign({}, response.data, {
        actionsAlign: NsGrid.ActionsAlign.Left,
        showAggr: true,
        showExpandedRow: true,
        filterMenuActions: (actions: any, record: any) => {
          const newActions: any[] = [];
          if (actions) {
            actions.forEach((item: any) => {
              if (record.amountInVat != 0) {
                if (item.name == 'Update') {
                  newActions.push(item);
                }
              }
            });
          }
          return newActions;
        },
      });

      const actions: any[] = [];
      if (settings.formSchema.actions) {
        settings.formSchema.actions.forEach((item: any) => {
          //只在 当前单据是审批中&本单支付方式(第一条明细的)<>货补(KA)&（有修改核销金额权限）& 核销金额(含税)<>0时才显示；点击后弹出图1.1
          if (wdiCore.String.EqIngoreCase(item.name, 'Update') && (allowModifyAmount)
            && (data.form?.statusId == Enum.FormStatus.AWAITING) && (dataSource[0]?.paymentMethodId != Enum.PaymentMethod.FREE_GOODS)) {
            Utility.setActionCallback(settings.formSchema.actions, 'Update',
              (grid: any, action: any, record: any) => {
                setModalProps({
                  title: '修改核销明细',
                  visible: true,
                  type: ModalAppTypeEnums.Edit,
                  id: null,
                  data: {
                    formSp: data.formSp,
                    row: record,
                  },
                });
              },
            );
            actions.push(item);
          }
        });
      }
      settings.formSchema.actions = actions;

      initFieldDisplayFormater(settings.formSchema.allFields);

      settings.formSchema.allFields.startDate.getDisplayFormater = (text: any, record: any, index: any,) => {
        return wdiCore.Date.DateToString(text);
      };

      settings.formSchema.allFields.amountSs.aggr = TableColumnRanderFormats.sumAggr('amountSs', 2,);
      settings.formSchema.allFields.amountNotPaid.aggr = TableColumnRanderFormats.sumAggr('amountNotPaid', 2,);
      settings.formSchema.allFields.amountInVat.aggr = TableColumnRanderFormats.sumAggr('amountInVat', 2,);
      settings.formSchema.allFields.amountExVat.aggr = TableColumnRanderFormats.sumAggr('amountExVat', 2,);

      settings.formSchema.allFields.rowNumber.width = 70;
      settings.formSchema.allFields.rebateInfoId.width = 120;
      settings.formSchema.allFields.fperiod.width = 100;
      settings.formSchema.allFields.soldToCode.width = 120;
      settings.formSchema.allFields.shipToCode.width = 100;
      settings.formSchema.allFields.ecId.width = 100;
      settings.formSchema.allFields.amountSs.width = 100;
      settings.formSchema.allFields.amountNotPaid.width = 120;
      settings.formSchema.allFields.amountInVat.width = 150;
      settings.formSchema.allFields.amountExVat.width = 165;
      settings.formSchema.allFields.remark.width = 100;
      settings.formSchema.allFields.productNamesRebate.width = 120;

      setGridSettings(settings);
      setIsLoaded(true);
    },);
  }, []);

  const pageGridSettings = Object.assign(
    {
      width: width - 300,
    },
    gridSettings,
  );
  pageGridSettings.antdProps = {
    dataSource,
    initRowFieldConfigs: (record: any) => {
      return initRowFieldConfigs(record);
    },
    pagination: {
      defaultPageSize: 10,
      showSizeChanger: true,
    },
  };

  const onClose = () => {
    setModalProps({visible: false, type: ModalAppTypeEnums.None});
  };
  const onImportSave = () => {
    onClose();
    props?.onClose?.();
    PageControl.approval({
      formTypeId: data.formSp?.formTypeId,
      pageTypeId: data.formSp?.pageTypeId,
      data: {formId: data.formSp?.formSpId},
    });
  };

  return (
    <>
      {modalProps.visible && modalProps.type == ModalAppTypeEnums.Edit && (
        <RebateSpDetailEditApp
          {...modalProps}
          onSave={(result) => {
            onChange?.(DataStore.edit(dataSource, result?.data));
            setModalProps({visible: false, data: null});
          }}
          onClose={onClose}
        />
      )}
      {modalProps.visible && modalProps.type == ModalAppTypeEnums.Import && (
        <ModifyPaymentAmountModalApp
          {...modalProps}
          onClose={onClose}
          onSave={onImportSave}
        />
      )}
      <WdiPanel
        title={<WdiCardTitle iconType={Enum.IconType.DETAIL_INFO} title="费用明细信息"/>}
        collapsed={true}
        defaultCollapsed={false}
        extra={
          <>
            {(doesAccess.modifyAmount)
              && (data.form?.statusId == Enum.FormStatus.AWAITING)
              && (dataSource.findIndex(m => m.paymentMethodId != Enum.PaymentMethod.FREE_GOODS && m.amountInVat != 0) > -1)
              && (
                <Button type='primary' onClick={(e) => {
                  setModalProps({
                    visible: true,
                    type: ModalAppTypeEnums.Import,
                    title: '批量修改核销明细',
                    id: data.formSp.formSpId,
                  });
                }} style={{float: 'right', marginRight: 10}}>
                  批量修改明细
                </Button>
              )
            }
            <Button
              type="primary"
              onClick={(e) => {
                const columns = [
                  {
                    name: 'rowNumber',
                    displayName: '行号',
                    type: Enum.FieldType.NUMBER,
                    dataType: Enum.FieldDataType.INT,
                  },
                  {name: 'rebateInfoId', displayName: '返利单编号'},
                  {name: 'soldToCode', displayName: '客户编号'},
                  {name: 'soldToName', displayName: '客户名称'},
                  {name: 'shipToCode', displayName: '收货地编号'},
                  {name: 'shipToName', displayName: '收货地名称'},
                  {name: 'fperiod', displayName: '预提月份'},
                  {name: 'ecName', displayName: '费用项'},
                  {name: 'amountSs', displayName: '结案金额'},
                  {name: 'amountNotPaid', displayName: '可报销金额'},
                  {name: 'amountInVat', displayName: '核销金额（含税）'},
                  {name: 'amountExVat', displayName: '核销金额（不含税）'},
                  {name: 'remark', displayName: '备注'},
                  {name: 'startDate', displayName: '销售开始日期'},
                  {name: 'endDate', displayName: '销售截止日期'},
                  {name: 'revenueTypeName', displayName: '核算类型'},
                  {name: 'paymentMethodName', displayName: '支付方式'},
                  {name: 'amountSa', displayName: '初始金额'},
                  {name: 'amountPaid', displayName: '已核销金额'},
                  {name: 'settlementExplain', displayName: '结案说明'},
                  {name: 'boName', displayName: '四级使用部门'},
                  {name: 'bohqName', displayName: '预算归属'},
                  {name: 'extPolicyName', displayName: '系统外政策/合同'},
                  {name: 'productNamesRebate', displayName: '产品别'},
                  {name: 'productCodesRebate', displayName: '产品别编号'},
                ];
                const sheet = {
                  data: dataSource,
                  names: columns,
                  sheetName: '核销明细',
                };
                toExcel({
                  name: props?.data?.form?.formNo + '_' + wdiCore.Date.ToString(new Date()) + '.xlsx',
                  sheetProps: [sheet],
                });
              }}
              style={{float: 'right'}}
            >
              导出
            </Button>
          </>
        }
      >
        {isLoaded && <DetailGrid {...pageGridSettings} />}
      </WdiPanel>
    </>
  );
};
